import { List, fromJS } from 'immutable';
import Cookie from 'js-cookie';
import { COOKIE_HIDDEN_CRISIS_ALERTS, DEFAULT_LANGUAGE } from '../../../config/constants';

import {
  ROOT_CLASSES_ADD,
  ROOT_CLASSES_REMOVE,
  LANGUAGE_SET,
  DISABLE_MAINTENANCE_MODE,
  ENABLE_MAINTENANCE_MODE,
  SET_CHECKBOX,
  SHOW_MOBILE_MENU,
  HIDE_MOBILE_MENU,
  SET_CURRENT_DOMAIN,
  CRISIS_ALERTS_FETCHED,
  TOGGLE_SUPPORT_TOOL,
  HIDE_CRISIS_ALERT,
} from '../../actions/UI';

import {
  REFERENCE_LOADING_START,
  REFERENCE_LOADING_DONE,
  REFERENCE_LOADING_RESET,
  REFERENCE_LOADING_ENABLE_PAGE_LOADER,
} from '../../actions/UI/ReferenceLoading';

const initialState = fromJS({
  language: DEFAULT_LANGUAGE,
  rootClasses: [],
  maintenanceMode: false,
  showMobileMenu: false,
  currentDomain: {
    raw: null,
    pretty: null,
  },
  referenceLoading: {
    itemsStarted: null,
    itemsFinished: null,
  },
  crisis_alerts: [],
  showSupportTool: false,
});

export default function ui(state = initialState, action = {}) {
  switch (action.type) {
    case ENABLE_MAINTENANCE_MODE: {
      return state.set('maintenanceMode', true);
    }

    case DISABLE_MAINTENANCE_MODE: {
      return state.set('maintenanceMode', false);
    }

    case LANGUAGE_SET: {
      return state.set('language', action.language);
    }

    case REFERENCE_LOADING_ENABLE_PAGE_LOADER: {
      return state.setIn(['referenceLoading', 'showPageLoader'], true);
    }

    case REFERENCE_LOADING_START: {
      const current = state.getIn(['referenceLoading', 'itemsStarted']);
      return state.setIn(['referenceLoading', 'itemsStarted'], current + 1);
    }

    case REFERENCE_LOADING_RESET: {
      return state.set('referenceLoading', initialState.get('referenceLoading'));
    }

    case SET_CHECKBOX: {
      return state.setIn(['webformState', action.id], action.checked);
    }

    case REFERENCE_LOADING_DONE: {
      const current = state.getIn(['referenceLoading', 'itemsFinished']);
      return state.setIn(['referenceLoading', 'itemsFinished'], current + 1);
    }

    case SHOW_MOBILE_MENU: {
      return state.set('showMobileMenu', true);
    }

    case HIDE_MOBILE_MENU: {
      return state.set('showMobileMenu', false);
    }

    case SET_CURRENT_DOMAIN: {
      return state.set('currentDomain', action.domain);
    }

    case ROOT_CLASSES_ADD: {
      const classes = List(
        typeof action.classes === 'string'
          ? action.classes.split(' ')
          : action.classes,
      );

      // Filter on those that we have to add.
      const newClasses = classes.filter((item) => {
        const index = state.get('rootClasses').findIndex((c) => c === item);
        return index === -1;
      });

      return state
        .update('rootClasses', (list) => list.merge(newClasses));
    }

    case ROOT_CLASSES_REMOVE: {
      const classes = List(
        typeof action.classes === 'string'
          ? action.classes.split(' ')
          : action.classes,
      );

      return state
        .update('rootClasses', (list) => list.filter((item) => {
          const index = classes.findIndex((c) => c === item);
          return index === -1;
        }));
    }

    case CRISIS_ALERTS_FETCHED: {
      const { payload } = action;

      const cookieHiddenCrisisAlerts = Cookie.get(COOKIE_HIDDEN_CRISIS_ALERTS);
      const hiddenCrisisAlerts = cookieHiddenCrisisAlerts ? JSON.parse(cookieHiddenCrisisAlerts) : [];
      const crisisAlerts = payload.filter((alert) => !hiddenCrisisAlerts.includes(alert.nid));

      return state
        .set('crisis_alerts', fromJS(crisisAlerts));
    }

    case HIDE_CRISIS_ALERT: {
      return state.set('crisis_alerts',
        state.get('crisis_alerts').filter((alert) => alert.get('nid') !== action.nid),
      );
    }

    case TOGGLE_SUPPORT_TOOL: {
      return state.set('showSupportTool', action.payload);
    }

    default:
      return state;
  }
}
